import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { useTranslation } from 'react-i18next';
import { ReactComponent as FacebookIcon } from "images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "images/instagram.svg";
import LogoImage from "images/logo.png";

const Container = tw.div`relative text-gray-700 -mb-8 -mx-8 px-8 py-20 lg:py-24`;
const Content = tw.div`max-w-screen-xl mx-auto relative z-10`;
const SixColumns = tw.div`flex flex-wrap text-center sm:text-left justify-center sm:justify-start md:justify-between -mt-12`;
const Column = tw.div`px-4 sm:px-0 sm:w-1/4 md:w-auto mt-12`;
const ColumnHeading = tw.h5`uppercase font-bold`;
const LinkList = tw.ul`mt-6 text-sm font-medium`;
const LinkListItem = tw.li`mt-3`;
const Link = tw.a`border-b-2 border-transparent hocus:border-gray-700 pb-1 transition duration-300`;
const Divider = tw.div`my-16 border-b-2 border-gray-300 w-full`;
const ThreeColRow = tw.div`flex flex-col md:flex-row items-center justify-between`;
const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const CopywrightNotice = tw.p`text-center text-sm sm:text-base mt-8 md:mt-0 font-medium text-gray-500`;
const SocialLinksContainer = tw.div`mt-8 md:mt-0 flex`;
const SocialLink = styled.a`
  ${tw`cursor-pointer p-2 rounded-full bg-gray-900 text-gray-100 hover:bg-gray-700 transition duration-300 mr-4 last:mr-0`}
  svg {
    ${tw`w-4 h-4`}
  }
`;
export default () => {
      const { t } = useTranslation();
  return (
    <Container style={{ backgroundColor: '#454f5e' }}>
      <Content>
        <SixColumns>
          <Column>
            <ColumnHeading style={{ color: '#ffffff' }}>{t('Principal')}</ColumnHeading>
            <LinkList style={{ color: '#ffffff' }}>
              <LinkListItem >
                <Link href="/">{t('Acceuil')}</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/Boutique">{t('Boutique')}</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/à-props">{t('à_propos')}</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/checkout">{t('Paiement')}</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/contact">{t('Contact')}</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/login">{t('Connexion')}</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/signup">{t('Inscription')}</Link>
              </LinkListItem>
              <LinkListItem>
                <Link href="/profile">{t('Profile')}</Link>
              </LinkListItem>
            </LinkList>
          </Column>
        </SixColumns>
        <Divider />
        <ThreeColRow>
          <LogoContainer>
          <img src={LogoImage} alt="Logo" width="200px" />
          {/* <LogoText>LadyCosmeticos</LogoText> */}
          </LogoContainer>
          <CopywrightNotice>&copy; {t('Created_by')} <a href="https://agencywmg.com/" style={{ color: '#133b8c' }}>
          agencywmg</a>. {t('All_Rights_Reserved')}.</CopywrightNotice>
          <SocialLinksContainer>
            <SocialLink href="https://facebook.com">
              <FacebookIcon />
            </SocialLink>
            <SocialLink href="https://twitter.com">
              <TwitterIcon />
            </SocialLink>
         
          </SocialLinksContainer>
        </ThreeColRow>
      </Content>
    </Container>
  );
};
